/* eslint-disable no-unused-vars */
import ClientLoginLocationViewModelType from '@/models/locations/clientLoginLocationViewModel'
import { BookingCommentType } from '@/shared/constants/booking/BookingCommentType'
import { ReasonsForAbsence } from '@/shared/constants/booking/ReasonsForAbsence'
import { ClientType } from '@/shared/constants/client/ClientType'
import calcTimeDifference from '@/utils/calc-time-difference'
import { nanoid } from 'nanoid'

// Abstract Product
/**
 *
 * @param {ClientLoginLocationViewModelType} selectedLocation
 * @param {*} submittedById
 * @returns
 */
const BaseBookingPayload = (selectedLocation, submittedById) => {
  const durationMinutes = calcTimeDifference(
    selectedLocation.startTime,
    selectedLocation.endTime,
    'minutes'
  )
  return {
    templates: [
      {
        certifications: [],
        id: nanoid(),
        confirmations: [],
        submittedByOrReplacing: submittedById,
        grades: [],
        classification: null,
        locationId: selectedLocation.locationId,
        startTimeLocation: selectedLocation.startTime,
        endTimeLocation: selectedLocation.endTime,
        durationMinutes,
        breakMinutes: selectedLocation.locationLunchBreakMinutes,
        notes: [
          {
            type: BookingCommentType.PRIVATE,
            content: '',
          },
          {
            type: BookingCommentType.CANDIDATE,
            content: '',
          },
          {
            type: BookingCommentType.CONTACT,
            content: '',
          },
        ],
        reason: ReasonsForAbsence[0].id, // Not Provided
      },
    ],
    bookings: [],
    groups: [],
  }
}

// Factory
export function BookingPayloadFactory(selectedLocation, submittedById) {
  switch (selectedLocation.clientTypeInt) {
    case ClientType.OSHC:
      return OshcBookingPayload(selectedLocation, submittedById)
    default:
      return BaseBookingPayload(selectedLocation, submittedById)
  }
}

// Concrete Products
const OshcBookingPayload = (selectedLocation, submittedById) => {
  return BaseBookingPayload(selectedLocation, submittedById)
}
